import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "KINGDOM ADVANCEMENT",
  "SOCIAL MEDIA MARKETING",
  "TELL YOUR STORY",
  "SHOW UP WELL",
  "ADVANCE YOUR PURPOSE",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    data-testid="marquee"
    className={`py-6 md:py-8 border-y ${dark ? "bg-navy-deep border-gold/25" : "bg-cream border-navy/15"}`}
  >
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <div key={i} className="flex items-center">
          <span
            className={`font-display uppercase text-3xl md:text-5xl tracking-wide px-8 ${
              dark ? "text-cream" : "text-navy"
            }`}
          >
            {t}
          </span>
          <span className="text-gold text-2xl md:text-4xl">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
